import React, { useRef } from "react";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptBar } from "@Local/Dashboard/dashboard.util";
/********* 主要暫停原因統計 *********/
const PauseReasons = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["醫生指示/受傷", "出國/出差/搬家", "個人因素/忙碌"],
			data: [22, 18, 12],
		},
	} = props;
	const { axisLabels = [], data = [] } = adaptBar(sourceData);
	const isLoading = data.length === 0;
	const title = "主要暫停原因統計";
	const option = {
		title: {
			text: title,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
			formatter: params => {
				const item = params[0];
				return `${item.name}<br/>${item.marker} ${item.value} 人`;
			},
		},
		grid: {
			left: 150,
			right: 20,
			top: 60,
			bottom: 20,
		},
		xAxis: [
			{
				type: "value",
				splitNumber: 5,
				axisLabel: { show: false },
				axisTick: { show: false },
				axisLine: { show: false },
				splitLine: {
					lineStyle: {
						type: "dashed",
						color: "#E5E7EB",
					},
				},
			},
		],
		yAxis: [
			{
				type: "category",
				inverse: true,
				data: axisLabels,
				axisTick: { show: false },
				axisLine: { show: false },
				axisLabel: {
					fontSize: 14,
					color: "#374151",
					margin: 10,
				},
			},
		],
		series: [
			{
				name: "Value",
				type: "bar",
				barWidth: "50%",
				data: data,
				itemStyle: {
					color: "#5B0F74",
					borderRadius: [0, 6, 6, 0],
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default PauseReasons;
